
import CenterWiseLeadsChart from './CenterWiseLeadsChart'

const ChartOverview = () => {
    return (
        <div className="chart-overview pb-80">
            <div className="container-fluid">
                <div className="row gy-4">
                    <div className="col-12">
                        <CenterWiseLeadsChart />
                    </div>
                </div>
            </div>
        </div>
    );
}
export default ChartOverview;